const PDF_URL = process.env.PUBLIC_URL + '/brochure.pdf';
const PDFJS_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
const PDFJS_WORKER = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
const PRE_RENDER_WIDTH = 1000;

function loadPdfJs() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    return new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[src="${PDFJS_CDN}"]`);
        if (existing) {
            existing.addEventListener('load', () => resolve(window.pdfjsLib));
            existing.addEventListener('error', reject);
            return;
        }
        const script = document.createElement('script');
        script.src = PDFJS_CDN;
        script.onload = () => resolve(window.pdfjsLib);
        script.onerror = reject;
        document.head.appendChild(script);
    });
}

// Step 1 & 2: load pdf.js and fetch file in parallel
const pdfjsPromise = loadPdfJs();
const fetchPromise = fetch(PDF_URL)
    .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.arrayBuffer(); })
    .catch(() => null);

// Step 3: parse as soon as both are ready
const pdfDocPromise = Promise.all([pdfjsPromise, fetchPromise])
    .then(([lib, buf]) => {
        lib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER;
        return lib.getDocument({ data: buf }).promise;
    })
    .catch(() => null);

// Step 4: pre-render page 1 during idle time so it's ready to display instantly
let page1Promise = null;

pdfDocPromise.then(doc => {
    if (!doc) return;
    const render = () => {
        page1Promise = (async () => {
            try {
                const page = await doc.getPage(1);
                const unscaled = page.getViewport({ scale: 1 });
                const viewport = page.getViewport({ scale: PRE_RENDER_WIDTH / unscaled.width });
                const canvas = document.createElement('canvas');
                canvas.width = viewport.width;
                canvas.height = viewport.height;
                await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;
                return canvas;
            } catch {
                return null;
            }
        })();
    };
    if ('requestIdleCallback' in window) {
        requestIdleCallback(render, { timeout: 3000 });
    } else {
        setTimeout(render, 1000);
    }
}).catch(() => {});

export async function getPdfDocument() {
    const doc = await pdfDocPromise;
    if (doc) return doc;
    // fallback if pre-parse failed
    const lib = await pdfjsPromise;
    lib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER;
    return lib.getDocument(PDF_URL).promise;
}

// Returns the pre-rendered page 1 canvas, or null if not ready yet
export function getPage1Preview() {
    return page1Promise;
}
